export const CONTACT_US_URL = 'EnvVar.CONTACT_US_URL.Link';
export const DASHBOARD_URL = `/accounts/v1/account/dashboard`;
export const LOGIN_WITH_RESERVATION_PAGE = '/login-by-reservation';
export const PAGE_NOT_FOUND = '/404';
export const RESET_PASSWORD_PAGE = '/reset-password';
export const RESET_PASSWORD_SUCCESS_PAGE = '/reset-password/success';
export const RESET_PASSWORD_ERROR_PAGE = '/reset-password/error';
export const SIGNIN_PAGE = '/signin';
export const SIGNUP_PAGE = '/signup';
